function crc32(bytes) {
  let crc = -1;
  for (let i = 0; i < bytes.length; i++) {
    crc ^= bytes[i];
    for (let bit = 0; bit < 8; bit++) {
      crc = (crc >>> 1) ^ (0xedb88320 & -(crc & 1));
    }
  }
  return (crc ^ -1) >>> 0;
}

function pushUint16(target, value) {
  target.push(value & 255, (value >>> 8) & 255);
}

function pushUint32(target, value) {
  target.push(value & 255, (value >>> 8) & 255, (value >>> 16) & 255, (value >>> 24) & 255);
}

function dosDateTime(date = new Date()) {
  const time =
    ((date.getHours() & 31) << 11) |
    ((date.getMinutes() & 63) << 5) |
    ((Math.floor(date.getSeconds() / 2)) & 31);
  const dosDate =
    (((date.getFullYear() - 1980) & 127) << 9) |
    (((date.getMonth() + 1) & 15) << 5) |
    (date.getDate() & 31);
  return { time, date: dosDate };
}

export function createZip(files) {
  const encoder = new TextEncoder();
  const chunks = [];
  const central = [];
  let offset = 0;
  const stamp = dosDateTime();

  files.forEach((file) => {
    const nameBytes = encoder.encode(file.name);
    const data = encoder.encode(file.content);
    const crc = crc32(data);
    const local = [];

    pushUint32(local, 0x04034b50);
    pushUint16(local, 20);
    pushUint16(local, 0);
    pushUint16(local, 0);
    pushUint16(local, stamp.time);
    pushUint16(local, stamp.date);
    pushUint32(local, crc);
    pushUint32(local, data.length);
    pushUint32(local, data.length);
    pushUint16(local, nameBytes.length);
    pushUint16(local, 0);
    local.push(...nameBytes);
    const localHeader = new Uint8Array(local);
    chunks.push(localHeader, data);

    const entry = [];
    pushUint32(entry, 0x02014b50);
    pushUint16(entry, 20);
    pushUint16(entry, 20);
    pushUint16(entry, 0);
    pushUint16(entry, 0);
    pushUint16(entry, stamp.time);
    pushUint16(entry, stamp.date);
    pushUint32(entry, crc);
    pushUint32(entry, data.length);
    pushUint32(entry, data.length);
    pushUint16(entry, nameBytes.length);
    pushUint16(entry, 0);
    pushUint16(entry, 0);
    pushUint16(entry, 0);
    pushUint16(entry, 0);
    pushUint32(entry, 0);
    pushUint32(entry, offset);
    entry.push(...nameBytes);
    central.push(new Uint8Array(entry));

    offset += localHeader.length + data.length;
  });

  const centralSize = central.reduce((sum, entry) => sum + entry.length, 0);
  const end = [];
  pushUint32(end, 0x06054b50);
  pushUint16(end, 0);
  pushUint16(end, 0);
  pushUint16(end, files.length);
  pushUint16(end, files.length);
  pushUint32(end, centralSize);
  pushUint32(end, offset);
  pushUint16(end, 0);

  return new Blob([...chunks, ...central, new Uint8Array(end)], { type: 'application/zip' });
}
